import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import authAction from "../Auth/actions";
import {
  addRoomFailure,
  //
  addRoomSuccess,
  addSlickCareProfilesFailure,
  //
  addSlickCareProfilesSuccess,
  deleteCareRoomFailure,
  //
  deleteCareRoomSuccess,
  deleteSlickCareProfilesFailure,
  //
  deleteSlickCareProfilesSuccess,
  editCareRoomFailure,
  editCareRoomSuccess,
  editSlickCareProfilesFailure,
  //
  editSlickCareProfilesSuccess,
  fetchAllLocationFailure,
  //
  fetchAllLocationSuccess,
  //
  fetchAllRooms,
  fetchAllRoomsFailure,
  fetchAllRoomsSuccess,
  fetchRoomsFailure,
  //
  fetchRoomsSuccess,
  fetchLocations as fetchSlickCareProfilesAction,
  fetchSlickCareProfilesFailure,
  fetchSlickCareProfilesSuccess,
  //
  getCareRoomData,
  getCareRoomDataFailure,
  //
  getCareRoomDataSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  inviteStaffFailure,
  //
  inviteStaffSuccess,
  profileStepEditFailure,
  //
  profileStepEditSuccess,
  searchSlickCareProfilesFailure,
  searchSlickCareProfilesSuccess,
  //
  inviteReviewSuccess,
  inviteReviewFailure,
  //
  fetchInviteesSuccess,
  fetchInviteesFailure,
  //
  generateCardSuccess,
  generateCardFailure,
  //
  exportReviewsSuccess,
  exportReviewsFailure,
  //
  deleteTeamSuccess,
  deleteTeamFailure,
  //
  updateSeqSuccess,
  updateSeqFailure,
  //
  getFees,
  getFeesSuccess,
  getFeesFailure,
  //
  updateFeeSuccess,
  updateFeeFailure,
  //
  getProfile as getProfileAction,
  getProfileSuccess,
  getProfileFailure,
  //
  deleteFileSuccess,
  deleteFileFailure,
  //
  deleteVideoSuccess,
  deleteVideoFailure,
  //
  getBackViewSuccess,
  getBackViewFailure,
} from "./actions";
import {
  ADD_ROOM,
  ADD_LOCATION,
  DELETE_CARE_ROOM,
  DELETE_LOCATION,
  EDIT_CARE_ROOM,
  EDIT_LOCATION,
  FETCH_ALL_LOCATION,
  FETCH_ALL_ROOMS,
  FETCH_ROOMS,
  FETCH_LOCATIONS,
  GET_CARE_ROOM_DATA,
  GET_VIEW_DATA,
  INVITE_STAFF,
  PROFILE_STEP_EDIT,
  SEARCH_LOCATION,
  INVITE_REVIEW,
  GENERATE_CARD,
  FETCH_INVITEES,
  EXPORT_REVIEWS,
  DELETE_TEAM,
  UPDATE_SEQ,
  GET_FEES,
  UPDATE_FEE,
  GET_PROFILE,
  DELETE_FILE,
  DELETE_VIDEO,
  GET_BACK_VIEW,
} from "./constants";

export function* fetchSlickCareProfilesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/location?${query}`);
    yield put(fetchSlickCareProfilesSuccess(data));
  } catch (e) {
    yield put(fetchSlickCareProfilesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching Location!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/location/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching Location!"));
  }
}

export function* addSlickCareProfilesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/location/add`, payload.data);
    if (data) {
      yield put(successAlert("Location added successfully!"));
      yield put(addSlickCareProfilesSuccess());
      if (payload?.history) {
        payload.history.push("/d/location");
      }
    }
  } catch (e) {
    yield put(addSlickCareProfilesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editSlickCareProfilesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/location/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Profile updated successfully!"));
      yield put(editSlickCareProfilesSuccess());
      yield put(getViewDataAction(payload.id));
      yield put(getProfileAction({ location_id: payload.id }));
    }
  } catch (e) {
    yield put(editSlickCareProfilesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteSlickCareProfilesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/location/${payload?.id}`);
    if (data) {
      yield put(successAlert("Location deleted successfully!"));
      yield put(deleteSlickCareProfilesSuccess());
      yield put(fetchSlickCareProfilesAction());
    }
  } catch (e) {
    yield put(deleteSlickCareProfilesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchSlickCareProfilesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/location?${query}`);
    yield put(searchSlickCareProfilesSuccess(data));
  } catch (e) {
    yield put(searchSlickCareProfilesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while searching Location!"));
  }
}

export function* fetchAllLocationSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/location?${query}`);
    yield put(fetchAllLocationSuccess(data));
  } catch (e) {
    yield put(fetchAllLocationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while searching Locations!"));
  }
}

export function* addRoomSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/care-room-types/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Room(s) added successfully!"));
      yield put(addRoomSuccess());
      yield put(getViewDataAction(payload.data.location_id));
    }
  } catch (e) {
    yield put(addRoomFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchRoomsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/type-of-room-and-count?${query}`
    );
    yield put(fetchRoomsSuccess(data));
  } catch (e) {
    yield put(fetchRoomsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching room!"));
  }
}

export function* fetchAllRoomsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/care-room?${query}`);
    yield put(fetchAllRoomsSuccess(data));
  } catch (e) {
    yield put(fetchAllRoomsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching rooms!"));
  }
}

export function* deleteCareRoomSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/care-room/delete`, payload);
    if (data) {
      yield put(successAlert("Room deleted successfully!"));
      yield put(deleteCareRoomSuccess());
      yield put(
        fetchAllRooms({ page: 1, limit: 10, location_id: payload.location_id })
      );
    }
  } catch (e) {
    yield put(deleteCareRoomFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getCareRoomSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/care-room/${payload}`);
    yield put(getCareRoomDataSuccess(data));
  } catch (e) {
    yield put(getCareRoomDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching care room!"));
  }
}

export function* editCareRoomSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/care-room/edit/${payload?.data?.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Room updated successfully!"));
      yield put(editCareRoomSuccess());
      yield put(getCareRoomData(payload?.data?.id));
    }
  } catch (e) {
    yield put(editCareRoomFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* inviteStaffSaga({ payload, onInvSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/invite-staff-mail`, payload);
    if (data) {
      yield put(successAlert("Invite sent successfully!"));
      yield put(inviteStaffSuccess());
      typeof onInvSuccess === "function" && onInvSuccess();
    }
  } catch (e) {
    yield put(inviteStaffFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while sending invite!"));
  }
}

export function* profileStepEditSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/location-stepper/${payload.id}`,
      payload?.data
    );
    if (data) {
      yield put(successAlert("Profile updated successfully!"));
      yield put(profileStepEditSuccess());
      typeof onSuccess === "function" && onSuccess(data?.data);
      if (payload?.data?.current_step === "faqs") {
        yield put(authAction.check(token, payload?.history));
      }
    }
  } catch (e) {
    yield put(profileStepEditFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating data!"));
  }
}

export function* inviteReviewSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/invite-review-mail`,
      payload
    );
    if (data) {
      yield put(successAlert("Your review invite is scheduled"));
      yield put(inviteReviewSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(inviteReviewFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while scheduling invite!"));
  }
}

export function* fetchInviteesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/invite-review-list?${query}`
    );
    yield put(fetchInviteesSuccess(data));
  } catch (e) {
    yield put(fetchInviteesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching invitees!"));
  }
}

export function* generateCardSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token, null, false, true).post,
      payload?.type === "Card"
        ? `/api/review-qr-card`
        : `/api/review-qr-poster`,
      payload?.data
    );
    if (data) {
      typeof onSuccess === "function" && onSuccess(data);
      yield put(generateCardSuccess());
    }
  } catch (e) {
    yield put(generateCardFailure());
    yield put(errorAlert(`Error while generating ${payload?.type}!`));
  }
}

export function* exportReviewsSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token, null, false, true).post,
      `/api/export-bulk-review`,
      payload?.data
    );
    typeof onSuccess === "function" && onSuccess();
    if (data) {
      yield put(successAlert(`${payload?.type} generated successfully!`));
      yield put(exportReviewsSuccess());
      if (payload?.data?.type === "CSV") {
        const csvContent = `data:text/csv;charset=utf-8,${data}`;
        const encodedURI = encodeURI(csvContent);
        window.open(encodedURI);
      } else {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${payload?.title} Reviews.${payload?.type}`
        );
        document.body.appendChild(link);
        link.click();
      }
    }
  } catch (e) {
    yield put(exportReviewsFailure());
    yield put(errorAlert(`No reviews available!`));
  }
}

export function* deleteTeamSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).delete,
      `/api/location-team/${payload.id}`
    );
    if (data) {
      yield put(deleteTeamSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(deleteTeamFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* updateSeqSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/update-file-sequence`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Sequence updated successfully!"));
      yield put(updateSeqSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(updateSeqFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getFeesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/location-fees?${query}`);
    yield put(getFeesSuccess(data));
  } catch (e) {
    yield put(getFeesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching listing!"));
  }
}

export function* updateFeeSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/location-fees/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(updateFeeSuccess());
      yield put(getFees(payload?.params));
    }
  } catch (e) {
    yield put(updateFeeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getProfileSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location-profile-list?${query}`
    );
    yield put(getProfileSuccess(data));
  } catch (e) {
    yield put(getProfileFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching listing!"));
  }
}

export function* deleteFileSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/location-file/${payload}`);
    if (data) {
      yield put(deleteFileSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(deleteFileFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteVideoSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).delete,
      `/api/location-video-delete/${payload}`
    );
    if (data) {
      yield put(deleteVideoSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(deleteVideoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getBackViewSaga({ payload, onBackSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token, null, false, true).get,
      `/api/review-form`
    );
    if (data) {
      typeof onBackSuccess === "function" && onBackSuccess(data);
      yield put(getBackViewSuccess());
    }
  } catch (e) {
    yield put(getBackViewFailure());
    yield put(errorAlert(`Error while generating form!`));
  }
}

export function* fetchSlickCareProfilesFlow() {
  yield takeEvery(FETCH_LOCATIONS, fetchSlickCareProfilesSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addSlickCareProfilesFlow() {
  yield takeEvery(ADD_LOCATION, addSlickCareProfilesSaga);
}
export function* editSlickCareProfilesFlow() {
  yield takeEvery(EDIT_LOCATION, editSlickCareProfilesSaga);
}
export function* deleteSlickCareProfilesFlow() {
  yield takeEvery(DELETE_LOCATION, deleteSlickCareProfilesSaga);
}
export function* searchSlickCareProfilesFlow() {
  yield takeEvery(SEARCH_LOCATION, searchSlickCareProfilesSaga);
}
export function* addRoomFlow() {
  yield takeEvery(ADD_ROOM, addRoomSaga);
}
export function* fetchRoomsFlow() {
  yield takeEvery(FETCH_ROOMS, fetchRoomsSaga);
}
export function* fetchAllLocationFlow() {
  yield takeEvery(FETCH_ALL_LOCATION, fetchAllLocationSaga);
}
export function* fetchAllRoomsFlow() {
  yield takeEvery(FETCH_ALL_ROOMS, fetchAllRoomsSaga);
}
export function* deleteCareRoomFlow() {
  yield takeEvery(DELETE_CARE_ROOM, deleteCareRoomSaga);
}
export function* getCareRoomFlow() {
  yield takeEvery(GET_CARE_ROOM_DATA, getCareRoomSaga);
}
export function* editCareRoomFlow() {
  yield takeEvery(EDIT_CARE_ROOM, editCareRoomSaga);
}
export function* inviteStaffFlow() {
  yield takeEvery(INVITE_STAFF, inviteStaffSaga);
}
export function* profileStepEditFlow() {
  yield takeEvery(PROFILE_STEP_EDIT, profileStepEditSaga);
}
export function* inviteReviewFlow() {
  yield takeEvery(INVITE_REVIEW, inviteReviewSaga);
}
export function* fetchInviteesFlow() {
  yield takeEvery(FETCH_INVITEES, fetchInviteesSaga);
}
export function* generateCardFlow() {
  yield takeEvery(GENERATE_CARD, generateCardSaga);
}
export function* exportReviewsFlow() {
  yield takeEvery(EXPORT_REVIEWS, exportReviewsSaga);
}
export function* deleteTeamFlow() {
  yield takeEvery(DELETE_TEAM, deleteTeamSaga);
}
export function* updateSeqFlow() {
  yield takeEvery(UPDATE_SEQ, updateSeqSaga);
}
export function* getFeesFlow() {
  yield takeEvery(GET_FEES, getFeesSaga);
}
export function* updateFeeFlow() {
  yield takeEvery(UPDATE_FEE, updateFeeSaga);
}
export function* getProfileFlow() {
  yield takeEvery(GET_PROFILE, getProfileSaga);
}
export function* deleteFileFlow() {
  yield takeEvery(DELETE_FILE, deleteFileSaga);
}
export function* deleteVideoFlow() {
  yield takeEvery(DELETE_VIDEO, deleteVideoSaga);
}
export function* getBackViewFlow() {
  yield takeEvery(GET_BACK_VIEW, getBackViewSaga);
}

export default function* SlickCareProfilesSaga() {
  yield all([
    fetchSlickCareProfilesFlow(),
    addSlickCareProfilesFlow(),
    editSlickCareProfilesFlow(),
    deleteSlickCareProfilesFlow(),
    getViewDataFlow(),
    searchSlickCareProfilesFlow(),
    addRoomFlow(),
    fetchRoomsFlow(),
    fetchAllLocationFlow(),
    fetchAllRoomsFlow(),
    deleteCareRoomFlow(),
    getCareRoomFlow(),
    editCareRoomFlow(),
    inviteStaffFlow(),
    profileStepEditFlow(),
    inviteReviewFlow(),
    fetchInviteesFlow(),
    generateCardFlow(),
    exportReviewsFlow(),
    deleteTeamFlow(),
    updateSeqFlow(),
    getFeesFlow(),
    updateFeeFlow(),
    getProfileFlow(),
    deleteFileFlow(),
    deleteVideoFlow(),
    getBackViewFlow(),
  ]);
}
